import { GET_YOUTUBE_VIDEOS_ANALYTICS_SUCCESS, GET_YOUTUBE_VIDEOS_ANALYTICS_FAILURE } from '../constants/actionTypes';

const INITIAL_STATE = { videos: [], errors: null };

export default function ytVideosAnalytics(state=INITIAL_STATE, action) {
  
  switch(action.type) {
    case GET_YOUTUBE_VIDEOS_ANALYTICS_SUCCESS:
      return { ...state, videos: action.payload.data, errors: null }
    case GET_YOUTUBE_VIDEOS_ANALYTICS_FAILURE:
      return { ...state, videos: [], errors: action.payload.response && action.payload.response.data.errors }
    default:
      return state;
  }
}
